import React from 'react';
import { BsCheck2Circle, BsClockHistory, BsPlus, BsXCircle } from 'react-icons/bs';

export const CompliceStatus = ({ status }) => {

    return (
        <>    { status === "REJECTED" ?
            <BsXCircle color="#fff" size={ 20 } /> :
            status === "REVIEWING" ?
                <BsClockHistory color="#fff" size={ 20 } /> :
                status === "APPROVED" ?
                    <BsCheck2Circle color="#fff" size={ 20 } /> :
                    <BsPlus color="#ff6A00" size={ 20 } />
        }
        </>
    );
};
